import { render, staticRenderFns } from "./allmarket.vue?vue&type=template&id=216b9998&scoped=true&"
import script from "./allmarket.vue?vue&type=script&lang=js&"
export * from "./allmarket.vue?vue&type=script&lang=js&"
import style0 from "./allmarket.vue?vue&type=style&index=0&id=216b9998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216b9998",
  null
  
)

export default component.exports